import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { isNil } from "lodash";
import {
  authActionStatusAtom,
  authPassportAtom,
  authErrorAtom,
  isAuthAtom,
} from "Recoil/auth.atom";
import { authLogin } from "Services/auth.services";
import { Col, Row, Space } from "antd";
import LoginForm from "Components/auth/login-form";
import "./login.scss";
import useRecaptchaV3 from "Hooks/recaptcha-v3.hook";

const LoginPage = () => {
  const history = useHistory();
  // version formatting = x.xx (e.g. 2.12)
  // 2 = project phase
  // 12 = current sprint
  const appVersion = process.env.APP_VER;
  const { t } = useTranslation();
  const [status, setStatus] = useRecoilState<any>(authActionStatusAtom);
  const [, setIsAuth] = useRecoilState<boolean>(isAuthAtom);
  const [, setAuthPassport] = useRecoilState<any>(authPassportAtom);
  const [error, setError] = useRecoilState<any>(authErrorAtom);
  const executeRecaptcha = useRecaptchaV3();

  const handleSubmit = async ({ email, password }) => {
    setStatus({ ...status, login: "loading" });
    const recaptchaToken = await executeRecaptcha("login");
    const responseData = await authLogin({ email, password, recaptchaToken });

    if (!isNil(responseData.error)) {
      setStatus({ ...status, login: "error" });
      setError(responseData?.error);
    } else {
      setStatus({ ...status, login: "success" });
      setAuthPassport(responseData);
      setIsAuth(true);
      history.push("/");
    }
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>{t("pageTitle.login")}</title>
      </Helmet>
      <div className="login-page">
        <div className="login-page--header"></div>
        <div className="login-page--main">
          <div className="login-page--container">
            <div className="section-left">
              <img
                alt={t("alt.logo")}
                src="/assets/images/logo_white.png"
                style={{
                  height: "50px",
                  width: "300",
                  maxWidth: "500px",
                }}
              />
              <h2 className="mt-30">The urban delivery solution</h2>
            </div>
            <div className="login-page--form">
              <div className="login-page--form-title">
                <Space direction="vertical" size="middle" className="center">
                  <h4 className="color-primary">{t("pageTitle.login")}</h4>
                </Space>
              </div>
              <LoginForm
                status={status.login}
                resError={error}
                onSubmit={handleSubmit}
              />
              <div className="login-page--bot"></div>
              <Row justify="space-between" align="middle">
                <Col>
                  <a
                    className="color-primary"
                    onClick={() => history.push("/track-trace")}
                  >
                    Track Parcels Here!
                  </a>
                </Col>
                <Col>
                  <span>v{appVersion}</span>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LoginPage;
